import React from 'react';

const RefundCancellation = () => (
  <div>
    <div className="page-header">
      <div className="container"><h1>Refund &amp; Cancellation</h1><p>Our policy on cancellations, returns, and refunds</p></div>
    </div>
    <div className="policy-content">
      <h2>Order Cancellation</h2>
      <p>Orders can be cancelled free of charge before they are shipped. Once an order has been dispatched, it cannot be cancelled but may be eligible for return as per our return policy.</p>

      <h2>Returns</h2>
      <p>We accept returns within 7 days of delivery for items that are defective, damaged in transit, or incorrect (wrong item shipped). To be eligible, the item must be unused, with all tags attached, in its original packaging, and accompanied by proof of purchase.</p>
      <p>For hygiene reasons, worn jerkins and used bags/trolleys are non-returnable unless they arrived defective or damaged.</p>

      <h2>Refund Process</h2>
      <p>Once your return is received and inspected, we will notify you of the approval status. Approved refunds are processed to your original payment method within 5–7 business days. COD orders are refunded via bank transfer.</p>

      <h2>Warranty Claims</h2>
      <p>Products are covered by the warranty stated on their product page (from 1 year on jerkins up to 10 years on flagship trolleys). Contact our support team with your Order ID to initiate a warranty claim for issues such as wheel, zip or handle failure under normal use.</p>

      <h2>How to Request a Return or Refund</h2>
      <p>Contact us at <a href="mailto:support@fivestar.example.com">support@fivestar.example.com</a> with your Order ID and reason for return, and our team will guide you through the process.</p>
    </div>
  </div>
);

export default RefundCancellation;
